import { Divider } from "antd";
import React from "react";

export default function AboutPageComp() {
  return (
    <section className="sectionDiv" style={{background:"#fbfbfb"}}>
      <div className="container">
        <h3 className="text-center home-about-us-title ">OUR JOURNEY</h3>
        <div className="home-about-us-line-outer-ant">
          <div className="home-about-us-line-inner-ant">
            <Divider />
          </div>
          <div className="home-about-us-dot-ant">
            <label>•</label>
          </div>
          <div className="home-about-us-line-inner-ant">
            <Divider />
          </div>
        </div>
        <div className="d-flex justify-content-center align-items-center flex-column">
          <h5 className="text-center">PLEASE TAKE A MOMENT TO SEE THE HISTORY OF OUR COMPANY</h5>
          <p className="text-center">
            We always had this statement and we're keeping our promise. To
            precede into being one of the biggest customer-centric company for
            our online, offline and overseas customers.
          </p>
        </div>

        <div class="timeline_bar">
          <div class="row">
            <div class="col-sm-12 end_timeline">
              <span>1965 › ESTABLISHMENT</span>
            </div>
            <div class="col-sm-12 col-md-6 offset-md-6" data-align="right">
              <div class="timeline_box">
                <div class="date">1965</div>

                <h4 class="htitle">Surat</h4>

                <p>Year One of diamond trade from Surat.</p>
              </div>
            </div>

            <div class="col-sm-12 col-md-6">
              <div class="timeline_box">
                <div class="date">1978</div>

                <h4 class="htitle">Mumbai</h4>

                <p>
                  Original Founders of Sejal Group started trading from Mumbai.
                </p>
              </div>
            </div>

            <div class="col-sm-12 col-md-6 offset-md-6" data-align="right">
              <div class="timeline_box">
                <div class="date">1983-84</div>

                <h4 class="htitle">Sejal Exports (India)</h4>

                <p>Establishment of Sejal Exports (India).</p>
              </div>
            </div>

            <div class="col-sm-12 col-md-6">
              <div class="timeline_box">
                <div class="date">1989</div>

                <h4 class="htitle">Bangkok</h4>

                <p>
                  Sejal Group started first overseas trade with dealer in
                  Bangkok.
                </p>
              </div>
            </div>

            <div class="col-sm-12 col-md-6 offset-md-6" data-align="right">
              <div class="timeline_box">
                <div class="date">1996</div>

                <h4 class="htitle">Singapore</h4>

                <p>
                  Singapore was another Milestone in the expansion of trade
                  avenues for Sejal Group.
                </p>
              </div>
            </div>

            <div class="col-sm-12 col-md-6">
              <div class="timeline_box">
                <div class="date">1998</div>

                <h4 class="htitle">Los Angeles &amp; New York</h4>

                <p>
                  Sejal Group ventured towards The West. With it’s first trade
                  with dealers in Los Angeles &amp; New York.
                </p>
              </div>
            </div>

            <div class="col-sm-12 col-md-6 offset-md-6" data-align="right">
              <div class="timeline_box">
                <div class="date">2000</div>

                <h4 class="htitle">Kuala Lumpur, Malaysia</h4>

                <p>
                  Sejal Group began its trade with dealers in Kuala Lumpur,
                  Malaysia.
                </p>
              </div>
            </div>

            <div class="col-sm-12 col-md-6">
              <div class="timeline_box">
                <div class="date">2004</div>

                <h4 class="htitle">Hong Kong</h4>

                <p>
                  With one of the biggest free port, Hong Kong opened the avenue
                  for trade in Far-East. Trading began in the year 2004 creating
                  a boost to overseas trade. With our dealers in Hong Kong we
                  want the trade relations to grow infinitely.
                </p>
              </div>
            </div>

            <div class="col-sm-12 col-md-6 offset-md-6" data-align="right">
              <div class="timeline_box">
                <div class="date">2006</div>

                <h4 class="htitle">Dubai</h4>

                <p>
                  Sejal's major trade began in Dubai in 2006. Dubai being the
                  central most location on global trade routes has provided duty
                  free zone for businesses. Middle East has made the trade with
                  all major countries possible. Our dealer situated in Dubai has
                  opened doors to do business globally.
                </p>
              </div>
            </div>

            <div class="col-sm-12 col-md-6">
              <div class="timeline_box">
                <div class="date">2018</div>
                <h4 class="htitle">Responsible Jewellery Council.</h4>
                <p>
                  We are happy and proud to announce about our membership with
                  Responsible Jewellery Council.
                </p>
              </div>
            </div>

            <div class="col-sm-12 end_timeline">
              <span>PRESENT</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
